import { Component, Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackComponent } from './login/callback/callback.component';
import { LogoutComponent } from './login/logout/logout.component';
import { TradersDashboardComponent } from './features/dashboards/traders-dashboard/traders-dashboard.component';
import { MorayEastDashboardComponent } from './features/dashboards/moray-east-dashboard/moray-east-dashboard.component';
import { MorayEastComponent } from './features/instructions-entry/moray-east/moray-east.component';
import { AdHocComponent } from './features/instructions-entry/ad-hoc/ad-hoc.component';
import { AdhocDashboardComponent } from './features/dashboards/adhoc-dashboard/adhoc-dashboard.component';
import { AdHocRetailComponent } from './features/instructions-entry/ad-hoc-retail/ad-hoc-retail.component';
import { MorayWestDashboardComponent } from './features/dashboards/moray-west-dashboard/moray-west-dashboard.component';
import { MorayWestComponent } from './features/instructions-entry/moray-west/moray-west.component';
import { FhcComponent } from './features/instructions-entry/fhc/fhc.component';
import { FhcDashboardComponent } from './features/dashboards/fhc-dashboard/fhc-dashboard.component';
import { DashboardsViewerComponent } from './features/dashboards-viewer/dashboards-viewer.component';
import { OktaAuthGuard } from '@engie-group/ngx-gem-spaas';
import { UnauthorizedComponent } from './login/unauthorized/unauthorized.component';
import { ResComponent } from './features/instructions-entry/res/res.component';

const routes: Routes = [
  {path: '', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'home', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'moweo', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'mowwl', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'fhc', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'retail', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'res', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
/*
  {path: '', component: TradersDashboardComponent, canActivate: [OktaAuthGuard]},
  {path: 'moweo', component: MorayEastDashboardComponent, canActivate: [OktaAuthGuard]},
  {path: 'mowwl', component: MorayWestDashboardComponent, canActivate: [OktaAuthGuard]},
  {path: 'fhc', component: FhcDashboardComponent, canActivate: [OktaAuthGuard]},
  {path: 'retail', component: AdhocDashboardComponent, canActivate: [OktaAuthGuard]},
*/
  {path: 'moweo-new', component: MorayEastComponent, canActivate: [OktaAuthGuard]},
  {path: 'moweo-new/:id', component: MorayEastComponent, canActivate: [OktaAuthGuard]},
  {path: 'mowwl-new', component: MorayWestComponent, canActivate: [OktaAuthGuard] },
  {path: 'mowwl-new/:id', component: MorayWestComponent, canActivate: [OktaAuthGuard] },
  {path: 'fhc-new', component: FhcComponent, canActivate: [OktaAuthGuard] },
  {path: 'fhc-new/:id', component: FhcComponent, canActivate: [OktaAuthGuard] },
  {path: 'res-new', component: ResComponent, canActivate: [OktaAuthGuard]},
  {path: 'res-new/:id', component: ResComponent, canActivate: [OktaAuthGuard]},
  {path: 'callback', component: CallbackComponent, canActivate: [OktaAuthGuard]},
  {path: 'moweo/adhoc-new', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'moweo/adhoc-new/:id', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'mowwl/adhoc-new', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'mowwl/adhoc-new/:id', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'retail/adhoc-new', component: AdHocRetailComponent, canActivate: [OktaAuthGuard]},
  {path: 'retail/adhoc-new/:id', component: AdHocRetailComponent, canActivate: [OktaAuthGuard]},
  {path: 'fhc/adhoc-new', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'fhc/adhoc-new/:id', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'res/adhoc-new', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'res/adhoc-new/:id', component: AdHocComponent, canActivate: [OktaAuthGuard]},
  {path: 'logout', component: LogoutComponent, canActivate: [OktaAuthGuard]},
  {path: 'dbv', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
  {path: 'unauthorized', component: UnauthorizedComponent},
  {path: '**', component: DashboardsViewerComponent, canActivate: [OktaAuthGuard]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

